import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.gap(3, 'column')};
  width: 100%;
`;

export const LabelsWrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(3)};
`;

export const Label = styled.label`
  display: block;
  font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
  font-weight: 400;
  line-height: ${props => props.theme.rem(props.isSmall ? 19 : 20)};
  color: ${props => props.theme.unisystem.input.label};
`;

export const HelperLabel = styled(Label)`
  color: ${props => props.theme.unisystem.input.helperLabel};
`;

export const MaxLength = styled.div`
  display: flex;
  margin-top: -6px;
  justify-content: flex-end;
  width: 100%;
  font-size: ${props => props.theme.rem(16)};
  font-weight: 400;
  line-height: ${props => props.theme.rem(20)};
  color: ${props =>
    props.isOnLimit ? props.theme.unisystem.input.maxLength.textLimit : props.theme.unisystem.input.maxLength.text};
`;

export const InsideLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.rem(12)};
  line-height: ${props => props.theme.rem(16)};
  color: ${props => props.theme.unisystem.input.insideLabel};
  text-transform: uppercase;
  ${({ theme }) => theme.gap(1)};

  & > svg {
    width: 16px;
    height: 16px;
  }
`;

export const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 9px;
  border: 1px solid ${props => props.theme.unisystem.input.border};
  border-radius: 8px;
  min-height: ${props => (props.isTextarea ? '98px' : props.isSmall ? '40px' : '48px')};
  ${({ theme }) => theme.gap(1)};
  background: ${props =>
    props.isDisabled
      ? props.theme.unisystem.input.disabled.background
      : props.theme.unisystem.input.disabled.backgroundDefault};

  span {
    display: flex;
    align-items: center;
    margin: 0;
    height: 100%;
    width: 100%;

    textarea,
    input {
      flex: 1;
      border: 0;
      background: transparent;
      max-width: 100%;
      height: 100%;
      font-weight: 500;
      font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
      line-height: ${props => props.theme.rem(props.isSmall ? 19 : 20)};
      resize: none;
      font-family: IntervalNextReg, sans-serif;
      color: ${props => props.theme.unisystem.input.text};

      &::placeholder {
        color: ${props => props.theme.unisystem.input.placeholder};
      }

      &:focus {
        border-color: transparent;
        outline: none;
      }

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &[type=number] {
        -moz-appearance: textfield;
      }
    }

    textarea {
      min-height: 78px;
    }
  }

  &:hover {
    background: ${props =>
      props.isDisabled
        ? props.theme.unisystem.input.disabled.background
        : props.theme.unisystem.input.focused.background};
  }

  ${props =>
    props.isFilled &&
    `
      background: ${props.theme.unisystem.input.filled.background};
      color: ${props.theme.unisystem.input.filled.text};
    `}

  ${props =>
    props.isSucceeded &&
    `
      border: 2px solid ${props.theme.unisystem.input.success.border};
      padding: ${props.theme.space(2)}
    `}

  ${props =>
    props.isFocused &&
    `
      border: 2px solid ${props.theme.unisystem.input.focused.border};
      color: ${props.theme.unisystem.input.focused.text};
      background: ${props.theme.unisystem.input.focused.background};
    `}

  ${props =>
    props.isDisabled &&
    `
      color: ${props.theme.unisystem.input.disabled.text};

      textarea,
      input {
        color: ${props.theme.unisystem.input.disabled.text};
      }
  `}

  ${props =>
    props.isErrored &&
    `
      border: 2px solid ${props.theme.unisystem.input.error.border};
      padding: ${props.theme.space(2)}
  `}
`;

export const Info = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: ${props => props.theme.unisystem.input.info.background};
  border-radius: 8px;
  height: ${props => (props.isSmall ? '40px' : '48px')};
  padding: 0 ${props => props.theme.space(6)};
  ${({ theme }) => theme.gap(2.5)};

  p {
    font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
    line-height: ${props => props.theme.rem(props.isSmall ? 19 : 20)};
    color: ${props => props.theme.unisystem.input.info.text};
  }
`;

export const Message = styled.p`
  font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
  line-height: ${props => props.theme.rem(props.isSmall ? 19 : 20)};
  color: ${props => props.theme.unisystem.input.message.text};

  ${props =>
    props.isErrored &&
    `
     color: ${props.theme.unisystem.input.message.errorColor};
    `}
`;

export const SystemMessage = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(2.5)};
  height: ${props => (props.isSmall ? '40px' : '48px')};
  padding-inline: 23px;
  font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
  line-height: ${props => props.theme.rem(props.isSmall ? 18 : 20)};
  background-color: ${props => props.theme.unisystem.input.errorSystem.background};
  color: ${props => props.theme.unisystem.input.errorSystem.color};
  border-radius: 8px;

  svg {
    g {
      stroke: ${props => props.theme.unisystem.input.errorSystem.iconColor};
    }
  }
`;
